import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/today.png'
import _imports_1 from '@/assets/yesday.png'
import _imports_2 from '@/assets/one.png'
import _imports_3 from '@/assets/two.png'
import _imports_4 from '@/assets/three.png'


const _withScopeId = n => (_pushScopeId("data-v-03dc007c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"min-height":"100vh"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1))
const _hoisted_4 = {
  key: 0,
  class: "sort"
}
const _hoisted_5 = {
  key: 0,
  src: _imports_2,
  alt: ""
}
const _hoisted_6 = {
  key: 1,
  src: _imports_3,
  alt: ""
}
const _hoisted_7 = {
  key: 2,
  src: _imports_4,
  alt: ""
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "总安装", -1))
const _hoisted_10 = { class: "form-val" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "总注册", -1))
const _hoisted_12 = { class: "form-val" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "新增付费用户数", -1))
const _hoisted_14 = { class: "form-val" }
const _hoisted_15 = { class: "form-amount" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "新增付费金额", -1))
const _hoisted_17 = { class: "form-val" }
const _hoisted_18 = { class: "form-amount" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "付费总金额", -1))
const _hoisted_20 = { class: "form-val" }
const _hoisted_21 = {
  key: 1,
  class: "form-amount"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "退款金额", -1))
const _hoisted_23 = { class: "form-val" }
const _hoisted_24 = {
  key: 2,
  class: "form-amount"
}
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "今日退款", -1))
const _hoisted_26 = { class: "form-val" }
const _hoisted_27 = {
  key: 3,
  class: "form-amount"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "本月累计退款", -1))
const _hoisted_29 = { class: "form-val" }
const _hoisted_30 = {
  key: 4,
  class: "form-amount"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-title" }, "   ", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-val" }, "   ", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]

import { FieldTimeOutlined, ClockCircleOutlined } from "@ant-design/icons-vue";
import { defineAsyncComponent, onMounted, reactive, ref, watch } from "vue";
import { sysDailyList, loginOut, resetPassword, dailyRefund } from "@/api/api";
import dayjs, { Dayjs } from "dayjs";
import { ts_to_time } from "@/utils/utils";

interface AppObject {
  dbName: string;
  image: string;
  packageName: string;
  newPayUserSumAmount: number;
  newPayUserNum: number;
  rechargeTotalAmount: number;
  newAndroidUser: number;
  newIosUser: number;
  reg: number;
  totalRevenue: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AllApp',
  props: {
    appData: {},
    dateTime: {},
    isConsume: { type: Boolean },
    isRefresh: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;
const appList = ref<Array<AppObject>>([]);
const dateValue = ref<Array<string>>([]);
const loading = ref(false);
const isXiaohao = ref(false);
const appListData = ref([] as Array<any>);
const appYesTodayListData = ref([] as Array<any>);
const allAppListData = ref([] as Array<any>);
const appListDataTemp = ref([] as Array<any>);
const monthRefundList = ref([] as Array<any>);

const appObject = ref<AppObject>({
  dbName: "",
  image: "",
  packageName: "",
  newPayUserSumAmount: 0,
  newPayUserNum: 0,
  rechargeTotalAmount: 0,
  reg: 0,
  newAndroidUser: 0,
  newIosUser: 0,
  totalRevenue: 0,
});
const count = ref(0);
const timer = ref();

const traverseData = async () => {
  console.log(appList.value, 'appList.value')
  if (!appList.value.length || loading.value) {
    return;
  }
  count.value = 0;
  allAppListData.value = JSON.parse(JSON.stringify(appList.value));
  appYesTodayListData.value = [];

  // var searchMonth = dayjs(dateValue.value[0]).month() + 1;
  // var curMonth = new Date(ts_to_time(Number(new Date()))).getMonth() + 1;
  // if (searchMonth === curMonth) {
  await getAppDataYesToday(appObject.value);
  // }
  appList.value.forEach(async (val, index) => {
    await getAppData(val);
    if (appList.value.length === count.value) {
      await sortHandle();
    }
  });
  loading.value = false;
};

onMounted(() => {
  appList.value = props.appData;
  dateValue.value = props.dateTime;
  console.log(props.dateTime);

  getDailyRefund({}).then((res) => {
    monthRefundList.value = res;
    traverseData();
  });
  setInterval(() => {
    traverseData();
    updateTime();
  }, 600000);
});

watch(
  () => props.appData,
  (cur, old) => {
    appList.value = cur;
    traverseData();
  }
);

watch(
  () => props.dateTime,
  (cur, old) => {
    dateValue.value = cur;
    traverseData();
  },
  { immediate: true }
);

watch(
  () => props.isRefresh,
  (cur, old) => {
    // traverseData();
  }
);

watch(
  () => props.isConsume,
  (cur, old) => {
    isXiaohao.value = cur;
    // traverseData();
  }
);

const updateTime = () => {
  if (
    Number(new Date(dayjs().format("YYYY-MM-DD HH:mm:ss"))) >=
    Number(new Date(dayjs().format("YYYY-MM-DD") + " 23:40:00"))
  ) {
    timer.value = setInterval(() => {
      if (dayjs().format("HH:mm:ss") === "00:00:10") {
        clearInterval(timer.value);
        timer.value = null;
        location.reload();
      }
      if (
        Number(new Date(dayjs().format("YYYY-MM-DD HH:mm:ss"))) >=
        Number(new Date(dayjs().format("YYYY-MM-DD") + " 00:00:20"))
      ) {
        clearInterval(timer.value);
        timer.value = null;
      }
    }, 1000);
  } else {
    clearInterval(timer.value);
    timer.value = null;
  }
};

// 按今日付费总金额排序
const sortHandle = async () => {
  var arr = allAppListData.value.sort((a, b) => {
    return b.totalRevenue - a.totalRevenue;
  });
  appListData.value = appYesTodayListData.value.concat(arr);
};
// 赋值数据
const assignmentHandle = (val: any, appData: any) => {
  var appObject = {
    dbName: appData.dbName,
    image: appData.image,
    packageName: val.packageName ? val.packageName : 0,
    newPayUserSumAmount: val.newPayUserSumAmount ? val.newPayUserSumAmount : 0,
    newPayUserNum: val.newPayUserNum ? val.newPayUserNum : 0,
    rechargeTotalAmount: val.rechargeTotalAmount ? val.rechargeTotalAmount : 0,
    reg: val.reg ? val.reg : 0,
    newAndroidUser: val.newAndroidUser ? val.newAndroidUser : 0,
    newIosUser: val.newIosUser ? val.newIosUser : 0,
    totalRevenue: val.totalRevenue ? val.totalRevenue : 0,
    refundAmount: val.refundAmount ? val.refundAmount : 0,
    monthRefundAmount: val.monthRefundAmount ? val.monthRefundAmount : 0,
  };
  return appObject;
};
// // 修改数据
const updateAppData = (data: any, objectData: any) => {
  for (const key in objectData) {
    data[key] = objectData[key];
    if (key === "monthRefundAmount") {
      data.monthRefundAmount = data.monthRefundAmount;
    }
  }
  return data;
};
// 赋值修改后的数据
var comparedApplist = (appData: any, data: any) => {
  // //console.log("=====222", data);
  allAppListData.value.forEach((val) => {
    if (val.dbName === appData.dbName) {
      val = updateAppData(val, assignmentHandle(data, appData));
    }
  });
};
// 赋值修改后今日昨日的数据
var comparedYesTodayApplist = (appData: any, data: any) => {
  appYesTodayListData.value.forEach((val) => {
    if (val.dbName === appData.dbName) {
      val = updateAppData(val, assignmentHandle(data, appData));
    }
  });
};
const getAppDataYesToday = (appData: AppObject) => {
  return new Promise<Array<AppObject>>((resolve, reject) => {
    var timeNum = Number(new Date()) - 3600 * 24 * 1000;
    const params = {
      dbName: appData.dbName,
      pageNo: 1,
      pageSize: 3,
      beginTime: dayjs(ts_to_time(timeNum)).format("YYYY-MM-DD"),
      endTime: dayjs().format("YYYY-MM-DD"),
      isUse: 0,
    };
    loading.value = true;
    sysDailyList(params).then((res) => {
      if (res.code === "200") {
        var paramsArr = res.data.records;
        if (paramsArr.length) {
          if (!appData.dbName) {
            var data2: any = paramsArr[2];
            if (!data2.packageName) {
              data2.packageName = "昨日数据";
              appYesTodayListData.value.unshift(
                assignmentHandle(data2, appData)
              );
            } else {
              comparedYesTodayApplist(appData, data2);
            }

            var data1: any = paramsArr[1];
            if (!data1.packageName) {
              data1.packageName = "今日数据";

              const monthRefund = monthRefundList.value.find(
                (item: any) =>
                  item.dbName === dayjs(new Date()).format("YYYY-MM-DD")
              );
              data1.monthRefundAmount = monthRefund.refundAmount;
              appYesTodayListData.value.unshift(
                assignmentHandle(data1, appData)
              );
            } else {
              comparedYesTodayApplist(appData, data1);
            }
          }
        }
        else{
          console.log('没有数据')
        }
      }
      // //console.log(appYesTodayListData.value);
      resolve(appYesTodayListData.value);
    });
  });
};

const getDailyRefund = async (params: any) => {
  return new Promise<any[]>((resolve, reject) => {
    dailyRefund(params).then((res) => {
      resolve(res.data);
    });
  });
};

const getAppData = (appData: AppObject) => {
  return new Promise<any[]>((resolve, reject) => {
    var monthRefund = monthRefundList.value.find(
      (item: any) => item.dbName === appData.dbName
    );
    const params = {
      dbName: appData.dbName,
      pageNo: 1,
      pageSize: 3,
      beginTime: dayjs(dateValue.value[0]).format("YYYY-MM-DD"),
      endTime: dayjs(dateValue.value[1]).format("YYYY-MM-DD"),
      isUse: 0,
    };
    loading.value = true;
    sysDailyList(params).then((res) => {
      count.value++;
      if (res.code === "200") {
        var paramsArr = res.data.records;
        if (paramsArr.length) {
          loading.value = false;
          if (paramsArr[0]) {
            if (appData.dbName) {
              var data1: any = paramsArr[0];
              data1.packageName = appData.packageName;
              data1.monthRefundAmount = monthRefund.refundAmount;
              comparedApplist(appData, data1);
            }
          } else {
            var data1: any = {};
            data1.packageName = appData.packageName;
            data1.monthRefundAmount = monthRefund.refundAmount;
            comparedApplist(appData, data1);
          }
        }

      }
      resolve(allAppListData.value);
    });
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_avatar = _resolveComponent("a-avatar")!
  const _component_a_card_meta = _resolveComponent("a-card-meta")!
  const _component_a_statistic = _resolveComponent("a-statistic")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createBlock(_component_a_spin, { spinning: loading.value }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_a_row, {
          type: "flex",
          gutter: [16, 16]
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appListData.value, (item, index) => {
              return (_openBlock(), _createBlock(_component_a_col, {
                key: item.dbName,
                xxl: 6,
                xl: 6,
                lg: 12,
                sm: 12,
                md: 12,
                xs: 24,
                order: 4
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_a_spin, { spinning: loading.value }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_card, {
                        hoverable: "",
                        style: {"width":"100%"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_card_meta, {
                            title: item.packageName
                          }, {
                            avatar: _withCtx(() => [
                              (item.image)
                                ? (_openBlock(), _createBlock(_component_a_avatar, {
                                    key: 0,
                                    src: item.image
                                  }, null, 8, ["src"]))
                                : _createCommentVNode("", true),
                              (item.packageName === '今日数据')
                                ? (_openBlock(), _createBlock(_component_a_avatar, { key: 1 }, {
                                    icon: _withCtx(() => [
                                      _hoisted_2
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true),
                              (item.packageName === '昨日数据')
                                ? (_openBlock(), _createBlock(_component_a_avatar, { key: 2 }, {
                                    icon: _withCtx(() => [
                                      _hoisted_3
                                    ]),
                                    _: 1
                                  }))
                                : _createCommentVNode("", true)
                            ]),
                            _: 2
                          }, 1032, ["title"]),
                          (index >= 2 && index <= 4)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                (index - 1 === 1)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                                  : _createCommentVNode("", true),
                                (index - 1 === 2)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                                  : _createCommentVNode("", true),
                                (index - 1 === 3)
                                  ? (_openBlock(), _createElementBlock("img", _hoisted_7))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_8,
                          _createElementVNode("p", null, [
                            _hoisted_9,
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item.reg + item.newAndroidUser + item.newIosUser
                    ? item.reg + item.newAndroidUser + item.newIosUser
                    : 0), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_11,
                            _createElementVNode("span", _hoisted_12, _toDisplayString(item.reg ? item.reg : 0), 1)
                          ]),
                          _createElementVNode("p", null, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item.newPayUserNum ? item.newPayUserNum : 0), 1)
                          ]),
                          _createElementVNode("p", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, [
                              _createVNode(_component_a_statistic, {
                                title: "",
                                prefix: "$",
                                precision: 2,
                                value: `${item.newPayUserSumAmount / 100
                      ? item.newPayUserSumAmount / 100
                      : 0
                    }`
                              }, null, 8, ["value"])
                            ])
                          ]),
                          _createElementVNode("p", _hoisted_18, [
                            _hoisted_19,
                            _createElementVNode("span", _hoisted_20, [
                              _createVNode(_component_a_statistic, {
                                title: "",
                                prefix: "$",
                                precision: 2,
                                value: `${item.totalRevenue / 100 ? item.totalRevenue / 100 : 0
                    }`
                              }, null, 8, ["value"])
                            ])
                          ]),
                          (
                item.packageName === '今日数据' ||
                item.packageName === '昨日数据'
              )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_21, [
                                _hoisted_22,
                                _createElementVNode("span", _hoisted_23, [
                                  _createVNode(_component_a_statistic, {
                                    title: "",
                                    prefix: "$",
                                    precision: 2,
                                    value: `${item.refundAmount / 100 ? item.refundAmount / 100 : 0
                    }`
                                  }, null, 8, ["value"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (
                item.packageName != '今日数据' &&
                item.packageName != '昨日数据'
              )
                            ? (_openBlock(), _createElementBlock("p", _hoisted_24, [
                                _hoisted_25,
                                _createElementVNode("span", _hoisted_26, [
                                  _createVNode(_component_a_statistic, {
                                    title: "",
                                    prefix: "$",
                                    precision: 2,
                                    value: `${item.refundAmount / 100 ? item.refundAmount / 100 : 0
                    }`
                                  }, null, 8, ["value"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.packageName != '昨日数据')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_27, [
                                _hoisted_28,
                                _createElementVNode("span", _hoisted_29, [
                                  _createVNode(_component_a_statistic, {
                                    title: "",
                                    prefix: "$",
                                    precision: 2,
                                    value: `${item.monthRefundAmount / 100
                      ? item.monthRefundAmount / 100
                      : 0
                    }`
                                  }, null, 8, ["value"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (item.packageName == '昨日数据')
                            ? (_openBlock(), _createElementBlock("p", _hoisted_30, _hoisted_33))
                            : _createCommentVNode("", true)
                        ]),
                        _: 2
                      }, 1024)
                    ]),
                    _: 2
                  }, 1032, ["spinning"])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["spinning"]))
}
}

})